import { createTheme, Direction, ThemeProvider } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import RTL from './RTL';
import logo from './logo.png';


export default function App() {
    const { t } = useTranslation();
    const theme = createTheme({
        direction: t('_dir') as Direction,
        palette: {
            primary: {
                main: '#0755E4',
            }
        },
        typography: {
            fontFamily: 'peyda'
        }
    });

    return (
        <ThemeProvider theme={theme}>
            <RTL direction={theme.direction}>
                <div className='flex flex-col h-full'>
                    <div className='flex border-b-2'>
                        <img className='m-2' src={logo} alt='logo' />
                        <div className='mt-3'>{t('header')}</div>
                    </div>
                    <div className='px-5 py-3 flex justify-center grow'>
                        <Outlet />
                    </div>
                </div>
            </RTL>
        </ThemeProvider>
    );
}
